const Menu = {
    pages: [
        {
            title: 'about-product',
            name: 'ABOUT_PRODUCT'
        },
        {
            title: 'situable-for',
            name: 'SITUABLE_FOR'
        },
        {
            title: 'how-works',
            name: 'HOW_WORKS'
        },
        {
            title: 'advantages',
            name: 'ADVANTAGES'
        },
        {
            title: 'contacts',
            name: 'CONTACTS'
        }
    ]
}

export default Menu;